import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const search: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <svg id="search" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
      <path
        id="Path_55"
        data-name="Path 55"
        d="M13.238,7.613a5.625,5.625,0,1,0,5.625,5.625A5.627,5.627,0,0,0,13.238,7.613ZM4.8,13.238a8.438,8.438,0,1,1,15.317,4.887L26.891,24.9A1.409,1.409,0,1,1,24.9,26.891l-6.774-6.774A8.439,8.439,0,0,1,4.8,13.238Z"
        transform="translate(-2.05 -2.05)"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path id="Path_56" data-name="Path 56" d="M0,0H28V28H0Z" fill="none" />
    </svg>
  ),
};
